<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Cooling Performance Inputs</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (airflowSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Actual Airflow:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="airflowSelection.Value"
                (change)="textSelectionChanged(airflowSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(airflowSelection.Name)"/>
              <label class="units-label">CFM</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (edbSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Entering Dry Bulb:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="edbSelection.Value"
                (change)="textSelectionChanged(edbSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(edbSelection.Name)"/>
              <label class="units-label">°F</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (ewbSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Entering Wet Bulb:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="ewbSelection.Value"
                (change)="textSelectionChanged(ewbSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(ewbSelection.Name)"/>
              <label class="units-label">°F</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (eftSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Entering Fluid Temperature:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="eftSelection.Value"
                (change)="textSelectionChanged(eftSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(eftSelection.Name)"/>
              <label class="units-label">°F</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (loadEftSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Load Entering Fluid Temp:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="loadEftSelection.Value"
                (change)="textSelectionChanged(loadEftSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(loadEftSelection.Name)"/>
              <label class="units-label">°F</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (performanceMethodSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Method:</label>
              <select class="halfWidthInputField" #performanceMethodInput
                [class.invalidConfigurationSelection]="isInvalidSelection(performanceMethodSelection.Name)"
                (change)="selectionChanged(performanceMethodSelection, performanceMethodInput.value)"
                [value]="performanceMethodSelection.Value.toString()">
                @for (allowable of performanceMethodSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="performanceMethodSelection.Value && performanceMethodSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (totalCapacitySelection && isMethodSelected('Total Capacity')) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Total Capacity:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="totalCapacitySelection.Value"
                (change)="textSelectionChanged(totalCapacitySelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(totalCapacitySelection.Name)"/>
              <label class="units-label">MBH</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (sensibleCapacitySelection && isMethodSelected('Sensible Capacity')) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Sensible Capacity:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="sensibleCapacitySelection.Value"
                (change)="textSelectionChanged(sensibleCapacitySelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(sensibleCapacitySelection.Name)"/>
              <label class="units-label">MBH</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (ldbSelection && isMethodSelected('LAT')) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Leaving Air Dry Bulb:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="ldbSelection.Value"
                (change)="textSelectionChanged(ldbSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(ldbSelection.Name)"/>
              <label class="units-label">°F</label>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (fluidFlowSelection && isMethodSelected('Fluid Flow')) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Fluid Flow Rate:</label>
              <input type="number" class="configuration-text-input-field" [(ngModel)]="fluidFlowSelection.Value"
                (change)="textSelectionChanged(fluidFlowSelection)"
                [class.invalidConfigurationSelection]="isInvalidSelection(fluidFlowSelection.Name)"/>
              <label class="units-label">GPM</label>
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
